<!-- Dummy -->
<svg:path
    [attr.d]="leftWallPoints()"
    stroke="url(#paint6_linear_7217_69040)"
    [attr.fill]="'var(--wall-bg-1)'" />

<svg:path
    stroke="url(#paint6_linear_7217_69040)"
    [attr.d]="rightWallPoints()"
    [attr.fill]="'var(--wall-bg-2)'" />

    